/**
 * Overlay DOM (Preact, sem JSX — hyperscript h(); `style` como string CSS para evitar atrito de
 * tipos com exactOptionalPropertyTypes). Doc 07 §6: cartas, telas de fim, Vila. Alvos ≥48px (ACC-1).
 */
import { h, render } from 'preact';
import type { Card } from '@rabbit2/shared/sim';
import { cardLabel } from './labels.ts';

const T = {
  noite: '#1A1633', nevoa: '#4A4173', luar: '#BFD7EA', creme: '#FFF3E0',
  cenoura: '#FF8A3D', magia: '#7C5CFF', vela: '#FFD166',
};

let root: HTMLDivElement | null = null;
function host(): HTMLDivElement {
  if (!root) {
    root = document.createElement('div');
    root.id = 'ui';
    root.setAttribute(
      'style',
      'position:fixed;inset:0;display:grid;place-items:center;' +
        'font-family:system-ui,sans-serif;pointer-events:none;z-index:50',
    );
    document.body.appendChild(root);
  }
  return root;
}

export function clearOverlay(): void {
  if (root) render(null, root);
}

const PAINEL =
  `pointer-events:auto;background:${T.noite}f2;border:2px solid ${T.nevoa};border-radius:16px;` +
  `padding:24px;max-width:90vw;text-align:center;color:${T.creme};box-shadow:0 0 40px ${T.luar}40`;

const botao = (cor: string): string =>
  `pointer-events:auto;cursor:pointer;min-width:180px;min-height:48px;background:${cor};` +
  `color:#1A1633;border:none;border-radius:16px;font-size:18px;font-weight:bold;padding:12px 24px`;

export function showDraft(cards: Card[], onPick: (c: Card) => void): void {
  const cartas = cards.map((c, i) => {
    const { titulo, sub, cor } = cardLabel(c);
    return h(
      'button',
      {
        'data-testid': 'draft-card', 'data-card-index': String(i), onClick: () => onPick(c),
        style:
          `pointer-events:auto;cursor:pointer;width:156px;min-height:156px;background:${T.nevoa};` +
          `border:3px solid ${cor};border-radius:16px;color:${T.creme};display:flex;` +
          `flex-direction:column;gap:8px;align-items:center;justify-content:center;padding:12px;font-size:16px`,
      },
      [
        // ACC-2: texto em alto contraste (o tipo é distinguido pela PALAVRA; a cor de acento fica na borda);
        // ACC-8: fonte ≥16px
        h('span', { style: `color:${T.creme};font-weight:bold;font-size:16px` }, sub),
        h('strong', { style: 'font-size:18px' }, titulo),
      ],
    );
  });
  render(
    h('div', { style: PAINEL }, [
      h('h2', { style: `margin:0 0 16px;color:${T.vela}` }, 'Escolha uma carta'),
      h('div', { style: 'display:flex;gap:12px;flex-wrap:wrap;justify-content:center' }, cartas),
    ]),
    host(),
  );
}

export function showDeath(luarGanho: number, onVila: () => void): void {
  render(
    h('div', { style: PAINEL }, [
      h('h2', { 'data-testid': 'death-overlay', style: `margin:0 0 8px;color:${T.luar}` }, 'Os Sonecos te ninaram 💤'),
      h('p', { style: 'margin:0 0 4px' }, 'Bons sonhos rendem Luar…'),
      h('p', { style: `margin:0 0 20px;color:${T.vela};font-size:22px` }, `+${luarGanho} 🌙 Luar de Sonho`),
      h('button', { 'data-testid': 'to-vila', onClick: onVila, style: botao(T.cenoura) }, 'Voltar à Vila'),
    ]),
    host(),
  );
}

export function showVictory(luarGanho: number, onVila: () => void): void {
  render(
    h('div', { style: PAINEL }, [
      h('h2', { 'data-testid': 'victory-overlay', style: `margin:0 0 8px;color:${T.vela}` }, '★ Engrenagem recuperada!'),
      h('p', { style: `margin:0 0 20px;color:${T.vela};font-size:22px` }, `+${luarGanho} 🌙 Luar`),
      h('button', { 'data-testid': 'to-vila', onClick: onVila, style: botao(T.cenoura) }, 'Voltar à Vila'),
    ]),
    host(),
  );
}

export function showVila(totalLuar: number, onPlay: () => void): void {
  render(
    h('div', { style: PAINEL }, [
      h('h1', { 'data-testid': 'vila', style: `margin:0 0 8px;color:${T.creme}` }, 'Vila dos Coelhos'),
      h('p', { style: `margin:0 0 4px;color:${T.luar}` }, 'O Grande Relógio Lunar parou à meia-noite…'),
      h('p', { 'data-testid': 'vila-luar', style: `margin:0 0 20px;color:${T.vela};font-size:24px` }, `🌙 Luar total: ${totalLuar}`),
      h('button', { 'data-testid': 'vila-play', onClick: onPlay, style: botao(T.cenoura) }, '▶ Jogar (nova Badalada)'),
    ]),
    host(),
  );
}
